import React from "react";
import { KpsPageContent } from "components/containers";
import ListDocumentTypes from "features/Admin/ListDocumentTypes";

const DocumentTypeListPage = () => (
  <KpsPageContent>
    <ListDocumentTypes />
  </KpsPageContent>
);

export default DocumentTypeListPage;
